import {domReady, iterateNodes} from './dom';

export default class HoverHandler {
    constructor(selectors) {
        this.selectors = selectors;
        this.hoverActiveClass = '-hoverable';
        this.hoverAllowed = false;
        this.lastDisabled = new Date();

        domReady(() => {
            document.addEventListener('touchstart', () => this.toggleHover(false) );
            document.addEventListener('click', () => this.toggleHover(false) );
            document.addEventListener('mousemove', () => this.toggleHover(true));
        });
    }

    toggleHover(activate) {
        if (this.hoverAllowed === activate) return;
        if (new Date() - this.lastDisabled < 50) return;

        if (activate === true) {
            iterateNodes(this.selectors, e => {
                if(e.classList){
                    e.classList.add(this.hoverActiveClass)   ;
                }
            });
        } else {
            iterateNodes(this.selectors, e => {
                if(e.classList){
                    e.classList.remove(this.hoverActiveClass);
                }
            });
            this.lastDisabled = new Date();
        }

        this.hoverAllowed = activate;
    }
}